import { useMemo } from 'react'
import { useAgency } from '~/api/queries/agency'
import { useActiveAgency } from '~/domains/users/hooks/useActiveAgency'
import { formatName } from '~/utils/names'

type AssignableUser = {
  id: number
  firstname?: string | null
  lastname?: string | null
}

/** Users of the active agency as dropdown options, `pinnedUser` (current user, current assignee) first when not among them. */
export const useAssigneeOptions = (pinnedUser?: AssignableUser | null) => {
  const { activeAgency } = useActiveAgency()
  const { data: agency } = useAgency(activeAgency?.id)

  return useMemo(() => {
    const users: AssignableUser[] = agency?.users ?? []
    const all =
      pinnedUser && !users.some((user) => user.id === pinnedUser.id)
        ? [pinnedUser, ...users]
        : users
    return all.map((user) => ({
      label: formatName(user),
      value: String(user.id)
    }))
  }, [agency, pinnedUser])
}
